<template>
  <nav class="global-navbar">
    <!-- top-navbar -->
    <nav id="topNavbar" class="top-navbar">
      <div class="container">
        <!-- navbar-container -->
        <div class="navbar-container">
          <router-link to="/">
            <img
              class="navbar-brand-img"
              src="@/assets/public/images/navbar/navbar-logo.svg"
              alt
            />
          </router-link>
          <div class="navbar-list">
            <!--<router-link to="/download-docs">Tải tập tin xuống</router-link>--><!--下載文件-->
            <div class="navbar-divider"></div>
            <a rel="noopener" href="https://fordays.com.tw/" target="_blank">Global Site</a>
          </div>
          <button class="navbar-toggle-btn" @click="toggleNavbarList">
            <span class="navbar-toggle-line"></span>
          </button>
        </div>
        <!-- navbar-container end -->
      </div>
    </nav>
    <!-- top-navbar end -->
    <!-- main-navbar  -->
    <nav class="main-navbar">
      <div class="container">
        <div :class="['main-navbar-list', { active: isNavbarListActive }]">
          <router-link to="/kakusan">Axit nucleic là gì?<!--何謂核酸？--></router-link>
          <router-link to="/safety">Chất lượng của Fudizi<!--富地滋的品質--></router-link>
          <router-link to="/products">Thông tin sản phẩm<!--產品資訊--></router-link>
          <router-link to="/news">tin tức mới nhất<!--最新消息--></router-link>
          <!-- <router-link to="/activity-list">活動訊息</router-link> -->
          <router-link to="/contribution">đóng góp xã hội<!--社會貢獻--></router-link>
          <router-link to="/company">trí tuệ doanh nghiệp<!--企業情報--></router-link>
          <!-- <router-link to="/login" class="red-gradient-btn"
            >會員專區</router-link> -->
          <div class="d-sm-none text-center py-3">
            <a
              class="mx-2"
              rel="noopener"
              href="https://www.fordays.com.tw/"
              target="_blank"
              >Global Site</a>
            <router-link class="mx-2" to="/download-docs">Tải tập tin xuống</router-link><!--下載文件-->
          </div>
        </div>
      </div>
    </nav>
    <!-- main-navbar end -->
  </nav>
</template>
<script>
export default {
  name: "PublicNavbar",
  data() {
    return {
      isNavbarListActive: true,
    };
  },
  methods: {
    toggleNavbarList() {
      this.isNavbarListActive = !this.isNavbarListActive;
    },
  },
};
</script>
